import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  buttonsParent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "10px",
    padding: "2rem 4rem",
    "@media (max-width: 480px)": {
      flexDirection: "column",
      padding: "1.25rem 1rem",
      "& button": { width: "100%" },
    },
  },
  addLater: {
    backgroundColor: "transparent",
    color: "#000000",
    border: "1px solid #ffc461",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  addEssential: {
    backgroundColor: "#ffc461",
    color: "#000000",
    border: "1px solid #ffc461",
    padding: "5px 10px",
    borderRadius: "5px",
    marginLeft: "10px",
    cursor: "pointer",
  },
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4ead8",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "80px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "20px",
    },
    "@media (max-width: 480px)": {
      height: "auto",
      padding: "16px",
      textAlign: "center",
      "& h2": { fontSize: "16px" },
    },
  },
  medicationModal: {
    width: "100%",
    overflow: "auto",
    // height: 600,
    borderRadius: "1rem 1rem 1rem 1rem",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    "& .mantine-Paper-root": {
      overflow: "initial !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Modal-header": {
      display: "none",
    },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
  },
}));

export default useStyles;
